const enturmacao_de_alunos = {
  path: "/enturmacao-de-alunos",
  redirect: "/enturmacao-de-alunos",
  meta: {
    breadCrumb: "Processo de Matrículas - Enturmação de Alunos",
  },
  children: [
    {
      path: "/enturmacao-de-alunos",
      name: "enturmacao_de_alunos",
      component: () =>
        import("@/views/EnturmacaoDeAlunos/EnturmacaoDeAlunosHome.vue"),
    },
  ],
};

export { enturmacao_de_alunos };
